import axiosInstance from '@/store/axios'
import { rejectError } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    aepParse ({ commit }, data) {
      const params = {}

      if (data.url) {
        params.url = data.url
      }

      return axiosInstance.get('/api/v1/aep-parse', {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },

    // eslint-disable-next-line no-unused-vars
    aepProjects ({ commit }, params) {
      if (!params) params = {}

      return axiosInstance.get('/api/v1/aep-projects', {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },

    // eslint-disable-next-line no-unused-vars
    createAEPProject ({ commit }, data) {
      const params = {}

      return axiosInstance.post('/api/v1/aep-projects', data, {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },

    // eslint-disable-next-line no-unused-vars
    patchAEPProject ({ dispatch }, data) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/aep-projects/${data.id}`,
        data: data,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },

    deleteAEPProject ({ dispatch }, project) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/v1/aep-projects/${project.id}`,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },

    // eslint-disable-next-line no-unused-vars
    nexrenderJobsCount ({ commit }, params) {
      if (!params) params = {}

      return axiosInstance.get('/api/v1/nexrender-jobs/$count', {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },

    // eslint-disable-next-line no-unused-vars
    nexrenderJobs ({ commit }, params) {
      if (!params) params = {}

      return axiosInstance.get('/api/v1/nexrender-jobs', {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },

    // eslint-disable-next-line no-unused-vars
    createNexrenderJob ({ commit }, data) {
      const params = {}

      return axiosInstance.post('/api/v1/nexrender-jobs/commands/create', data, {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },

    // eslint-disable-next-line no-unused-vars
    nexrenderJobTemplates ({ commit }, params) {
      if (!params) params = {}

      return axiosInstance.get('/api/v1/nexrender-job-templates', {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },

    // eslint-disable-next-line no-unused-vars
    createNexrenderJobTemplate ({ commit }, data) {
      return axiosInstance.post(
        '/api/v1/nexrender-job-templates',
        data,
      )
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },

    // eslint-disable-next-line no-unused-vars
    patchNexrenderJobTemplate ({ dispatch }, data) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/nexrender-job-templates/${data.id}`,
        data: data,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },

    deleteNexrenderJobTemplate ({ dispatch }, template) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/v1/nexrender-job-templates/${template.id}`,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },

    // eslint-disable-next-line no-unused-vars
    channels ({ commit }, params) {
      if (!params) params = {}

      return axiosInstance.get('/api/v1/channels', {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },

    // eslint-disable-next-line no-unused-vars
    channelTemplates ({ commit }, params) {
      if (!params) params = {}

      return axiosInstance.get('/api/v1/channel-templates', {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },

    createChannelTemplate ({ commit }, params) {
      if (!params) params = {}

      return axiosInstance.post('/api/v1/channel-templates', params)
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },

    deleteChannelTemplate ({ dispatch }, t) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/v1/channel-templates/${t.id}`,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },

    // eslint-disable-next-line no-unused-vars
    playoutSettings ({ commit }, params) {
      if (!params) params = {}

      return axiosInstance.get('/api/v1/playout-settings', {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },

    // eslint-disable-next-line no-unused-vars
    patchPlayoutSetting ({ dispatch }, data) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/playout-settings/${data.id}`,
        data,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },

    // eslint-disable-next-line no-unused-vars
    fonts ({ commit }, params) {
      if (!params) params = {}

      return axiosInstance.get('/api/v1/fonts', {
        params,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    channelTemplateResources ({ commit }, params) {
      if (!params) params = {}

      return axiosInstance.get(
        '/api/v1/channel-template-resources',
        {
          params,
        },
      )
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
  },
}
